import { render, staticRenderFns } from "./ContactDetailsPage.vue?vue&type=template&id=57889f25&scoped=true&"
import script from "./ContactDetailsPage.vue?vue&type=script&lang=js&"
export * from "./ContactDetailsPage.vue?vue&type=script&lang=js&"
import style0 from "./ContactDetailsPage.vue?vue&type=style&index=0&id=57889f25&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57889f25",
  null
  
)

export default component.exports